import styled from 'styled-components'

import { DARK_GREY_BG_COLOR } from '@CSSVars/colors'


export const _Container = styled.div`
  padding: 20px 0 45px 0;
/*  background: ${DARK_GREY_BG_COLOR};*/
  border-radius: 10px;

  p {
    margin-bottom: 10px;
    font-size: 14px !important;
  }

  p > strong:nth-child(1) {
    margin: 0 0 10px 0;
  }

  p > strong {
    display: inline-block;
    margin: 10px 0;
  }

  div, h2, p, h3 {
/*    color: white;*/
    line-height: 22px;
  }

  h2 {
    line-height: 32px;
    font-size: 28px;
    margin-top: 25px;
  }

/*  em {
    color: white;
  }

  strong {
    color: white;
  }*/
`
